import {
	Anchor,
	Flex,
	Popover,
	Text,
	Textarea,
	TextareaProps,
} from '@mantine/core';
import { FC } from 'react';
import { SlQuestion } from 'react-icons/sl';

interface Props extends TextareaProps {
	tooltip?: { content: string };
}

export const AppTextarea: FC<Props> = (props) => {
	return (
		<Textarea
			minRows={4}
			autosize
			{...props}
			label={
				props.tooltip ? (
					<Flex
						w="100%"
						justify="space-between"
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
						}}
					>
						<Text>{props.label}</Text>
						<Popover width={300}>
							<Popover.Target>
								<Anchor
									c="black"
									lh={0}
									onClick={(e) => {
										e.preventDefault();
									}}
								>
									<SlQuestion />
								</Anchor>
							</Popover.Target>
							<Popover.Dropdown>
								<Text size="md">{props.tooltip.content}</Text>
							</Popover.Dropdown>
						</Popover>
					</Flex>
				) : (
					props.label
				)
			}
		/>
	);
};
